import * as React from "react";
import { TextArea as AriaTextArea, type TextAreaProps as AriaTextAreaProps } from "react-aria-components";

import { cn } from "./utils";

export interface TextareaProps extends Omit<AriaTextAreaProps, "className"> {
  className?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <AriaTextArea
        ref={ref}
        data-slot="textarea"
        className={cn(
          "resize-none border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 invalid:ring-destructive/20 dark:invalid:ring-destructive/40 invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-input-background px-3 py-2 text-base transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
